
    var content = require("!!../../css-loader/index.js??ref--5-rules-1!../../postcss-loader/lib/index.js??ref--5-rules-3!./style.css");
    var insertCss = require("!../../isomorphic-style-loader/lib/insertCss.js");

    if (typeof content === 'string') {
      content = [[module.id, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (module.hot && typeof window !== 'undefined' && window.document) {
      var removeCss = function() {};
      module.hot.accept("!!../../css-loader/index.js??ref--5-rules-1!../../postcss-loader/lib/index.js??ref--5-rules-3!./style.css", function() {
        content = require("!!../../css-loader/index.js??ref--5-rules-1!../../postcss-loader/lib/index.js??ref--5-rules-3!./style.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  